var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWatchTimer(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.25 1.125H6.75V2.625H11.25V1.125ZM8.25 10.875H9.75V6.375H8.25V10.875ZM14.2725 5.9175L15.3375 4.8525C15.015 4.47 14.6625 4.11 14.28 3.795L13.215 4.86C12.0525 3.93 10.59 3.375 9 3.375C5.2725 3.375 2.25 6.3975 2.25 10.125C2.25 13.8525 5.265 16.875 9 16.875C12.735 16.875 15.75 13.8525 15.75 10.125C15.75 8.535 15.195 7.0725 14.2725 5.9175ZM9 15.375C6.0975 15.375 3.75 13.0275 3.75 10.125C3.75 7.2225 6.0975 4.875 9 4.875C11.9025 4.875 14.25 7.2225 14.25 10.125C14.25 13.0275 11.9025 15.375 9 15.375Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWatchTimer);
export default __webpack_public_path__ + "static/media/watch-timer.990a845f1a241f66b47031a74baa4167.svg";
export { ForwardRef as ReactComponent };